"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrap = exports.SearchButton = exports.LogoWrapper = exports.IcisLogo = exports.HomePageToggleWrapper = exports.HeaderWrapper = exports.HamburgerButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IcisLogo = _interopRequireDefault(require("../../../IcisLogo"));
var _templateObject; //
const {
  colours,
  spacing,
  media
} = _uiKit.theme;
const HeaderWrapper = exports.HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "Headerstyle__HeaderWrapper",
  componentId: "sc-1nwruym-0"
})(["display:flex;justify-content:space-between;"]);
const TextWrap = exports.TextWrap = _styledComponents.default.span.withConfig({
  displayName: "Headerstyle__TextWrap",
  componentId: "sc-1nwruym-1"
})(["line-height:15px;"]);
const HamburgerButton = exports.HamburgerButton = _styledComponents.default.button.withConfig({
  displayName: "Headerstyle__HamburgerButton",
  componentId: "sc-1nwruym-2"
})(["background-color:", ";flex:0 0 50px;height:52px;width:52px;border:none;text-align:center;pointer-events:", ";"], _ref => {
  let {
    isMenuOpen
  } = _ref;
  return isMenuOpen ? colours.WHITE : 'transparent';
}, _ref2 => {
  let {
    isMenuOpen
  } = _ref2;
  return isMenuOpen ? 'none' : 'all';
});
const LogoWrapper = exports.LogoWrapper = _styledComponents.default.div.withConfig({
  displayName: "Headerstyle__LogoWrapper",
  componentId: "sc-1nwruym-3"
})(["display:flex;justify-content:center;flex:1 1 auto;align-self:center;"]);
const IcisLogo = exports.IcisLogo = (0, _styledComponents.default)(_IcisLogo.default).withConfig({
  displayName: "Headerstyle__IcisLogo",
  componentId: "sc-1nwruym-4"
})(["width:auto;height:22px;margin:0px;"]);
const SearchButton = exports.SearchButton = _styledComponents.default.button.withConfig({
  displayName: "Headerstyle__SearchButton",
  componentId: "sc-1nwruym-5"
})(["background-color:", ";border:none;padding:0 ", ";position:relative;z-index:4;outline:none;cursor:pointer;flex:0 0 50px;width:52px;height:52px;text-align:center;"], _ref3 => {
  let {
    isSearchShowing
  } = _ref3;
  return isSearchShowing ? colours.WHITE : 'transparent';
}, spacing.BASE_1);
const HomePageToggleWrapper = exports.HomePageToggleWrapper = _styledComponents.default.div.withConfig({
  displayName: "Headerstyle__HomePageToggleWrapper",
  componentId: "sc-1nwruym-6"
})(["display:none;align-items:center;margin-right:20px;span{left:-82px;color:white;font-size:12px;}", ""], media.md(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["display: flex;"]))));